/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { utils, Contract, ContractFactory } from "ethers";
var _abi = [
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "hash",
                type: "bytes32",
            },
        ],
        name: "governanceActionIsConsumed",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "impl",
                type: "address",
            },
        ],
        name: "isInitialized",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "wormhole",
        outputs: [
            {
                internalType: "contract IWormhole",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "chainId",
        outputs: [
            {
                internalType: "uint16",
                name: "",
                type: "uint16",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "governanceChainId",
        outputs: [
            {
                internalType: "uint16",
                name: "",
                type: "uint16",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "governanceContract",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "pyth2WormholeChainId",
        outputs: [
            {
                internalType: "uint16",
                name: "",
                type: "uint16",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "pyth2WormholeContract",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "product",
                type: "bytes32",
            },
            {
                internalType: "uint8",
                name: "priceType",
                type: "uint8",
            },
        ],
        name: "latestAttestation",
        outputs: [
            {
                components: [
                    {
                        internalType: "uint32",
                        name: "magic",
                        type: "uint32",
                    },
                    {
                        internalType: "uint16",
                        name: "version",
                        type: "uint16",
                    },
                    {
                        internalType: "uint8",
                        name: "payloadId",
                        type: "uint8",
                    },
                    {
                        internalType: "bytes32",
                        name: "productId",
                        type: "bytes32",
                    },
                    {
                        internalType: "bytes32",
                        name: "priceId",
                        type: "bytes32",
                    },
                    {
                        internalType: "uint8",
                        name: "priceType",
                        type: "uint8",
                    },
                    {
                        internalType: "int64",
                        name: "price",
                        type: "int64",
                    },
                    {
                        internalType: "int32",
                        name: "exponent",
                        type: "int32",
                    },
                    {
                        components: [
                            {
                                internalType: "int64",
                                name: "value",
                                type: "int64",
                            },
                            {
                                internalType: "int64",
                                name: "numerator",
                                type: "int64",
                            },
                            {
                                internalType: "int64",
                                name: "denominator",
                                type: "int64",
                            },
                        ],
                        internalType: "struct PythStructs.Ema",
                        name: "twap",
                        type: "tuple",
                    },
                    {
                        components: [
                            {
                                internalType: "int64",
                                name: "value",
                                type: "int64",
                            },
                            {
                                internalType: "int64",
                                name: "numerator",
                                type: "int64",
                            },
                            {
                                internalType: "int64",
                                name: "denominator",
                                type: "int64",
                            },
                        ],
                        internalType: "struct PythStructs.Ema",
                        name: "twac",
                        type: "tuple",
                    },
                    {
                        internalType: "uint64",
                        name: "confidenceInterval",
                        type: "uint64",
                    },
                    {
                        internalType: "uint8",
                        name: "status",
                        type: "uint8",
                    },
                    {
                        internalType: "uint8",
                        name: "corpAct",
                        type: "uint8",
                    },
                    {
                        internalType: "uint64",
                        name: "timestamp",
                        type: "uint64",
                    },
                ],
                internalType: "struct PythStructs.PriceAttestation",
                name: "attestation",
                type: "tuple",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
];
var _bytecode = "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";
var PythGetters__factory = /** @class */ (function (_super) {
    __extends(PythGetters__factory, _super);
    function PythGetters__factory(signer) {
        return _super.call(this, _abi, _bytecode, signer) || this;
    }
    PythGetters__factory.prototype.deploy = function (overrides) {
        return _super.prototype.deploy.call(this, overrides || {});
    };
    PythGetters__factory.prototype.getDeployTransaction = function (overrides) {
        return _super.prototype.getDeployTransaction.call(this, overrides || {});
    };
    PythGetters__factory.prototype.attach = function (address) {
        return _super.prototype.attach.call(this, address);
    };
    PythGetters__factory.prototype.connect = function (signer) {
        return _super.prototype.connect.call(this, signer);
    };
    PythGetters__factory.createInterface = function () {
        return new utils.Interface(_abi);
    };
    PythGetters__factory.connect = function (address, signerOrProvider) {
        return new Contract(address, _abi, signerOrProvider);
    };
    PythGetters__factory.bytecode = _bytecode;
    PythGetters__factory.abi = _abi;
    return PythGetters__factory;
}(ContractFactory));
export { PythGetters__factory };
